var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_101696",
    "data-name": "Group 101696",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.5,
    height: 35.5,
    viewBox: "0 0 35.5 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20046",
    "data-name": "Rectangle 20046",
    width: 35.5,
    height: 35.5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101696-2",
    "data-name": "Group 101696",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20044",
    "data-name": "Path 20044",
    d: "M17.75,0A17.75,17.75,0,1,0,35.5,17.75,17.767,17.767,0,0,0,17.75,0m0,33.6A15.85,15.85,0,1,1,33.6,17.75,15.868,15.868,0,0,1,17.75,33.6",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20045",
    "data-name": "Path 20045",
    d: "M17.75,4.8a.943.943,0,0,0-.95.95v12a.95.95,0,0,0,.95.95h12a.956.956,0,0,0,.95-.95A12.991,12.991,0,0,0,17.75,4.8m.95,12V6.73l.27.04a11.018,11.018,0,0,1,9.76,9.75l.03.28Z",
    fill: "#59687d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ1);
export default __webpack_public_path__ + "static/media/q1.e2641552aa1d94452f9554b9e1de33ec.svg";
export { ForwardRef as ReactComponent };